import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import HubspotLogo from './HubspotLogo.vue'

export const hubspotIntegration: PreviewIntegration = {
  id: 'hubspot',
  name: 'Hubspot',
  description:
    'Integrate your customer data from Hubspot into Go to give your AI context on your sales and marketing efforts.',
  icon: HubspotLogo,
}
